// tslint:disable:no-bitwise
export enum GatewayStatus {
  Offline = 0,
  Connecting = 1,
  Syncing = 2,
  Online = 3,
  Disconnecting = 4,
}
